import React from 'react'

const CartList = () => {
  return (
    <div>CartList</div>
  )
}

export default CartList